const LIVE_PREFIX = 'https://datadesk-prod-origin.californiatimes.com';
const TEST_PREFIX = 'https://elections-2024-backend-dev.s3.amazonaws.com';

export const TRENDS = `${LIVE_PREFIX}/projects/elections-data/2024-11-05/latest-trends.json`;

export const PRESIDENT = `${LIVE_PREFIX}/projects/elections-data/2024-11-05/latest-president.json`;

export const USHOUSE_URL = `${LIVE_PREFIX}/projects/elections-data/2024-11-05/latest-house.json`;

export const USGOV_URL = `${LIVE_PREFIX}/projects/elections-data/2024-11-05/latest-gov.json`;

export const US_PRES = `${LIVE_PREFIX}/projects/elections-data/2024-11-05/latest-us.json`;

export const STATE_URL = `${LIVE_PREFIX}/projects/elections-data/2024-11-05/latest-state.json`;

export const DA_URL = `${LIVE_PREFIX}/projects/elections-data/2024-11-05/latest-DA.json`;

export const SENATE_URL = `${LIVE_PREFIX}/projects/elections-data/2024-11-05/latest-senate.json`;

// counties
export const LA_COUNTY_URL = `${LIVE_PREFIX}/projects/elections-data/2024-11-05/la.json`;

export const OC_URL = `${LIVE_PREFIX}/projects/elections-data/2024-11-05/oc.json`;

export const SD_URL = `${LIVE_PREFIX}/projects/elections-data/2024-11-05/sd.json`;

/////////NATIONAL
export const US_GEOGRAPHYURL = `${LIVE_PREFIX}/projects/elections-data/2024-11-05/geographies/us.json`;

// OTHER
export const GEOGRAPHY_URL = `${LIVE_PREFIX}/projects/elections-data/2024-11-05/geographies/ca.json`;

// Number of presidential candidates to show
export const PRES_COUNT_NATIONAL = 2;
export const PRES_COUNT_CALIFORNIA = 2;
